import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Anchor } from "grommet";
import SampleFillinblanks from "./SampleFillinblanks.js";
import Spinner from "../../sample/spinner";
import Chip from "@material-ui/core/Chip";
import Latex from "./Latex.js";

class MwaAssesment extends Component {
  constructor(props) {
    super(props);
    const fillthegapasslist = [];

    this.state = {
      contentType: props.contentType,
      contentId: props.contentId,
      fillthegapasslist,
      isshowanswer: false,
      assid: "",
      showComponent: false,
    };
   
    this.handleclick = this.handleclick.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId
    ) {
      this.setState({
        contentType: this.props.contentType,
        contentId: this.props.contentId,
      });
      if (this.props.contentType === "Topiclevel") {
        this.getfillthegapdata();
      } else {
        // this.getUnitMcq();
      }
    }
  }

  componentDidMount() {
    this.getfillthegapdata();
  }

  async getfillthegapdata() {
    this.setState({ showComponent: true });
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topic", this.props.contentId);

    axios
      .post("LearnerAssignment/getFillTheGapAssignment", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            fillthegapasslist: res.data.fillthegapasslist,
            showComponent: false,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  handleclick(e, assid) {
    // console.log("handleclick");
    this.setState({ isshowanswer: !this.state.isshowanswer, assid: assid });
  }

  render() {
    return (
      <div>
        {/* Mwa Page<br/>
                Content type=
                {this.state.contentType}<br/>
                contentId ={this.state.contentId} */}

        {this.state.showComponent === true ? 
<>
<Spinner />
</>: 
""}
        <div class="row">
          <div className="col-lg-6">
            <Chip
              label="Fill The Gap"
              variant="outlined"
              className="ft-size"
              color="primary"
            />
          </div>
        </div>
<br />
<div id="style-6" class="scrollmcq">
        {this.state.fillthegapasslist ? (
          <>
            {this.state.fillthegapasslist.map((item, indexitem) => (
              <>
               <div class="card p-3 mb-2">
                <div class="row">
                  <div class="col-md-9 col-lg-9 text-left">
                    <label for={item.assignmenttext}>
                    {item.srno} ) &nbsp;
                      Question &nbsp;
                      <Latex>  
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item.assignmenttext,
                        }}
                      /></Latex>
                    </label>
                  </div>
                  <div class="col-lg-3 col-md-3 text-right">
                    {item.weightage === null || item.weightage === 0 ? (
                      <>
                      <Chip
                      label="Non Graded "
                      className="ft-size"
                    />
                      </>
                    ) : (
                      <>
                      <Chip
                    label={"weightage :"+ item.weightage}
                    className="ft-size"
                  />
                      
                      </>
                    )}
                  </div>
                </div>
                {item.savedmwaAnswerlist !== null ? (
                  <>
                    <Anchor
                      onClick={(e) => this.handleclick(e, item.assignmentid)}
                    >
                      {" "}
                      Show Previous Answer
                    </Anchor>
                  </>
                ) : (
                  ""
                )}

                {this.state.isshowanswer === true &&
                item.savedmwaAnswerlist !== null &&
                this.state.assid === item.assignmentid ? (
                  <>
                    <br />
                    {item.savedmwaAnswerlist.map((items, indexitems) => (
                      <>
                        <label>
                          {indexitems + 1} &nbsp;&nbsp;<Latex>{items.savedanswer}</Latex>
                        </label>

                        <br />
                      </>
                    ))}
                  </>
                ) : (
                  ""
                )}

                <SampleFillinblanks
                  mwaarraylist={item.mwaarraylist}
                  assid={item.assignmentid}
                  assoffid={item.assignmentOfferingid}
                />
                </div>
              </>
            ))}
          </>
        ) : (
          ""
        )}
        </div>
      </div>
    );
  }
}

export default MwaAssesment;
